import { INPUT_FILE_FORMATS } from 'modules/merchantinfo/constants/constants';

export const BENEFICIARY_STATUS = {
  SUCCEEDED: 'succeeded',
  ACTIVE: 'active',
  IN_REVIEW: 'in_review',
  REJECTED: 'rejected',
};

export const BENEFICIARY_TAB_TITLES = {
  SUCCEEDED: 'Succeeded',
  IN_REVIEW: 'In Review',
  REJECTED: 'Rejected',
};

export const BENEFICIARY_TABS = [
  {
    title: BENEFICIARY_TAB_TITLES.SUCCEEDED,
    statuses: [BENEFICIARY_STATUS.SUCCEEDED, BENEFICIARY_STATUS.ACTIVE],
  },
  {
    title: BENEFICIARY_TAB_TITLES.IN_REVIEW,
    statuses: [BENEFICIARY_STATUS.IN_REVIEW],
  },
  {
    title: BENEFICIARY_TAB_TITLES.REJECTED,
    statuses: [BENEFICIARY_STATUS.REJECTED],
  },
];

export const BENEFICIARY_TABLE_HEADINGS = [
  'Created At',
  'Beneficiary Id',
  'Beneficiary Name',
  'Merchant',
  'Account Number',
  'Bank',
  'Currency',
  'Payout Method',
  'Document',
  'Status',
];

export const SUPER_MERCHANT_TABLE_HEADINGS = ['Super Merchant', 'Super Merchant Id', 'Code', 'Country', 'Status'];

export const BENEFICIARY_UPDATABLE_STATUS_OPTIONS = [
  { label: 'Active', value: BENEFICIARY_STATUS.ACTIVE },
  { label: 'In Review', value: BENEFICIARY_STATUS.IN_REVIEW },
  { label: 'Rejected', value: BENEFICIARY_STATUS.REJECTED },
];

export const BENEFICIARY_STATUS_BADGE_COLORS = {
  [BENEFICIARY_STATUS.SUCCEEDED]: 'green',
  [BENEFICIARY_STATUS.ACTIVE]: 'green',
  [BENEFICIARY_STATUS.IN_REVIEW]: 'orange',
  [BENEFICIARY_STATUS.REJECTED]: 'red',
};

export const BENEFICIARY_DOCUMENT_ACCEPTED_FORMATS = [
  INPUT_FILE_FORMATS.PNG,
  INPUT_FILE_FORMATS.JPEG,
  INPUT_FILE_FORMATS.JPG,
  INPUT_FILE_FORMATS.PDF,
].join(', ');

export const BENEFICIARY_DOCUMENT_MAX_SIZE_BYTES = 10 * 1024 * 1024;

export const BENEFICIARY_DEFAULT_PAGE_SIZE = 10;

export const BENEFICIARY_DETAIL_SECTIONS = [
  {
    title: 'Beneficiary',
    fields: [
      { label: 'Beneficiary Id', key: 'id' },
      { label: 'Name', key: 'beneficiary_name' },
      { label: 'Alias', key: 'beneficiary_alias' },
      { label: 'Account Type', key: 'beneficiary_account_type' },
      { label: 'Email', key: 'beneficiary_email' },
      { label: 'Contact Number', key: 'beneficiary_contact_number' },
      { label: 'Date Of Incorporation / Birth', key: 'beneficiary_date_of_incorporation_or_birth' },
      { label: 'Line Of Business', key: 'beneficiary_line_of_business' },
      { label: 'Relationship', key: 'beneficiary_relationship' },
      { label: 'Tax Reference Number', key: 'beneficiary_tax_reference_number' },
    ],
  },
  {
    title: 'Ownership',
    fields: [
      { label: 'Merchant Id', key: 'merchant_id' },
      { label: 'Merchant Name', key: 'merchant_name' },
      { label: 'Super Merchant Id', key: 'super_merchant_id' },
      { label: 'Parent Type', key: 'parent_type' },
      { label: 'Counter Party Id', key: 'counter_party_id' },
      { label: 'Customer Reference Id', key: 'customer_reference_id' },
    ],
  },
  {
    title: 'Beneficiary Address',
    fields: [
      { label: 'Address', key: 'beneficiary_address' },
      { label: 'Address Line 1', key: 'beneficiary_address_line1' },
      { label: 'Address Line 2', key: 'beneficiary_address_line2' },
      { label: 'City', key: 'beneficiary_city' },
      { label: 'State', key: 'beneficiary_state' },
      { label: 'Postcode', key: 'beneficiary_postcode' },
      { label: 'Country Code', key: 'beneficiary_country_code' },
    ],
  },
  {
    title: 'Bank Details',
    fields: [
      { label: 'Account Number', key: 'beneficiary_account_number' },
      { label: 'Bank Name', key: 'beneficiary_bank_name' },
      { label: 'Bank Code', key: 'beneficiary_bank_code' },
      { label: 'Bank Type', key: 'beneficiary_bank_type' },
      { label: 'Bank Account Type', key: 'beneficiary_bank_account_type' },
      { label: 'Bank Address', key: 'beneficiary_bank_address' },
      { label: 'Bank Address Line 1', key: 'beneficiary_bank_address_line1' },
      { label: 'Bank Address Line 2', key: 'beneficiary_bank_address_line2' },
      { label: 'Bank City', key: 'beneficiary_bank_city' },
      { label: 'Bank State', key: 'beneficiary_bank_state' },
      { label: 'Bank Postcode', key: 'beneficiary_bank_postcode' },
      { label: 'Bank Country Code', key: 'beneficiary_bank_country_code' },
    ],
  },
  {
    title: 'Routing',
    fields: [
      { label: 'Destination Currency', key: 'destination_currency' },
      { label: 'Destination Country', key: 'destination_country' },
      { label: 'Payout Method', key: 'payout_method' },
      { label: 'Transfer Type', key: 'transfer_type' },
      { label: 'Routing Code Type 1', key: 'routing_code_type_1' },
      { label: 'Routing Code Value 1', key: 'routing_code_value_1' },
      { label: 'Routing Code Type 2', key: 'routing_code_type_2' },
      { label: 'Routing Code Value 2', key: 'routing_code_value_2' },
    ],
  },
];
